import { SESSION_STATUS_LABELS, type SessionStatusHistoryEntry } from '@diana/contracts';
import { useState } from 'react';

export type ShootHistoryState = {
  entries: SessionStatusHistoryEntry[];
  pending?: boolean;
  error?: boolean;
  retry?(): void;
};
export function formatHistoryDate(value: string, now = new Date()) {
  const date = new Date(value);
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() !== now.getFullYear() ? { year: 'numeric' as const } : {}),
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}
export function ShootHistory({
  createdAt,
  history,
}: {
  createdAt: string;
  history?: ShootHistoryState;
}) {
  const [expanded, setExpanded] = useState(false);
  const entries = history?.entries ?? [];
  return (
    <section className="shoot-history" aria-label="Shoot history">
      <p className="shoot-history__received">
        Received <time dateTime={createdAt}>{formatHistoryDate(createdAt)}</time>
      </p>
      {history?.pending ? <p role="status">Loading status history…</p> : null}
      {history?.error ? (
        <p role="status">
          Could not load status history.{' '}
          <button className="shoot-button shoot-button--text" onClick={history.retry}>
            Retry
          </button>
        </p>
      ) : null}
      {entries.length ? (
        <>
          <ol>
            {(expanded ? entries : entries.slice(0, 3)).map((entry) => (
              <li key={entry.id}>
                <span>
                  {SESSION_STATUS_LABELS[entry.fromStatus]} <span aria-hidden="true">→</span>
                  <span className="sr-only"> to </span> {SESSION_STATUS_LABELS[entry.toStatus]}
                </span>
                <time dateTime={entry.changedAt}>{formatHistoryDate(entry.changedAt)}</time>
              </li>
            ))}
          </ol>
          {entries.length > 3 ? (
            <button
              className="shoot-button shoot-button--text"
              aria-expanded={expanded}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Show less' : `Show all ${entries.length} changes`}
            </button>
          ) : null}
        </>
      ) : null}
    </section>
  );
}
